import { render, staticRenderFns } from "./ConfigurationSize.vue?vue&type=template&id=0372cfc5&scoped=true&"
import script from "./ConfigurationSize.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSize.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationSize.vue?vue&type=style&index=0&id=0372cfc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372cfc5",
  null
  
)

export default component.exports